import { FC, useCallback, useEffect } from 'react';
import { WaiverFormDto } from '../../../models/dto';
import { EventWaiverTypeEnum } from '../../../constants';
import { useWaiverModalState } from '../hooks/use-waiver-modal-state.hook';
import { CoreRadio, CoreRadioGroup, RadioFormLabel } from '../../_core';
import { TextField } from '../../inputs';
import { waiverFormStyles } from './waiver-modal.styles';
import { RightBlackModal } from '../../right-modal';
import { customResetForm } from '../../../utils';

const defaultValues: WaiverFormDto = {
	waiverType: EventWaiverTypeEnum.Text,
	waiverText: null,
	waiverUrl: null,
};

export interface WaiverModalProps {
	open: boolean;
	data?: WaiverFormDto;
	onClose(isDirty?: boolean): void;
	onSubmit?(data: WaiverFormDto): void;
}

export const WaiverModal: FC<WaiverModalProps> = (props) => {
	const {
		open,
		data = defaultValues,
		onClose,
		onSubmit,
	} = props;

	const handleSave = useCallback((data: WaiverFormDto) => {
		onSubmit?.(data);
	}, [onSubmit]);

	const {
		form,
		formData,
		register
	} = useWaiverModalState({
		defaultValues: structuredClone(data),
	});

	const handleClose = useCallback(() => {
		onClose?.(form.formState.isDirty);
	}, [onClose, form]);

	useEffect(() => {
		if (open) {
			customResetForm(form, structuredClone(data));
		}
	}, [open, data, form]);

	const styles = waiverFormStyles();

	return (
		<RightBlackModal
			open={open}
			onClose={handleClose}
			headerTitle='Waiver Settings'
			modalProps={{
				component: 'form',
				onSubmit: form.handleSubmit(handleSave),
			}}
			submitButtonProps={{
				type: 'submit',
			}}
		>
			<CoreRadioGroup
				row
				name="event-waiver-types"
				value={formData?.waiverType}
				controlSx={styles.radioGroup}
				onChange={(_, value) => {
					form.setValue('waiverType', value as EventWaiverTypeEnum);
					form.setValue('waiverUrl', null);
					form.setValue('waiverText', null);
				}}
			>
				<RadioFormLabel value={EventWaiverTypeEnum.Text} control={<CoreRadio />} label="Text Waiver" />
				<RadioFormLabel value={EventWaiverTypeEnum.Url} control={<CoreRadio />} label="Link to waiver" />
			</CoreRadioGroup>

			{formData?.waiverType === EventWaiverTypeEnum.Url ? (
				<TextField
					{...register('waiverUrl')}
					sx={{
						borderRadius: '250px',
					}}
					placeholder='Add a link to your waiver'
					fullWidth
				/>
			) : (
				<TextField
					{...register('waiverText')}
					multiline
					minRows={4}
					maxRows={19}
					placeholder='Enter a waiver text'
					fullWidth
				/>
			)}
		</RightBlackModal>
	);
};
